// autogenerated by channel_search/generate.py -- do not edit
import { skybus_ws_subscribe_t } from "@skydio/lcm/types/skybus_websocket/skybus_ws_subscribe_t";
export { skybus_ws_subscribe_t };

export const SKYBUS_WS_SUBSCRIBE = {
  channel: "SKYBUS_WS_SUBSCRIBE",
  channelId: 4718,
  type: skybus_ws_subscribe_t
};
